import { ArrowDownRight, ArrowRight, ArrowUpRight } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { deltaTone, formatDelta } from '@/lib/format/delta';
import { cn } from '@/lib/utils';

interface Props {
  deltaPct: number;
  /** If true, negative delta is "good" (e.g. churn falling). */
  invert?: boolean;
  /** Comparison is not meaningful (previous=0). Renders as "no baseline". */
  comparable?: boolean;
  className?: string;
  size?: 'sm' | 'md';
}

export function DeltaBadge({
  deltaPct,
  invert,
  comparable = true,
  className,
  size = 'sm',
}: Props) {
  if (!comparable) {
    return (
      <Badge
        variant="muted"
        className={cn(
          size === 'md' ? 'px-2 py-1 text-xs' : 'px-1.5 py-0.5 text-2xs',
          'font-mono tabular-nums',
          className,
        )}
      >
        no baseline
      </Badge>
    );
  }
  const tone = deltaTone(deltaPct, { invert });
  const variant = tone === 'positive' ? 'positive' : tone === 'negative' ? 'negative' : 'muted';
  const Icon = tone === 'positive' ? ArrowUpRight : tone === 'negative' ? ArrowDownRight : ArrowRight;
  return (
    <Badge
      variant={variant}
      className={cn(
        size === 'md' ? 'px-2 py-1 text-xs' : 'px-1.5 py-0.5 text-2xs',
        'font-mono tabular-nums',
        className,
      )}
    >
      <Icon className="h-3 w-3" aria-hidden />
      {formatDelta(deltaPct)}
    </Badge>
  );
}
